import styled from 'styled-components'

/**
 * Quiet on purpose: the answer is what the page is about. The row sits under
 * the answer in the tertiary text tone and only the pressed rating takes the
 * brand colour.
 */
export const StyledActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--m-spacing-1);
  margin-top: var(--m-spacing-2);
`

export const StyledAction = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--m-spacing-1);
  padding: var(--m-spacing-1) var(--m-spacing-2);
  border: 0;
  border-radius: var(--m-border-radius-s);
  background: none;
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-2);
  color: rgb(var(--m-color-text-tertiary));
  cursor: pointer;

  &:hover {
    color: rgb(var(--m-color-primary-100));
    background-color: rgb(var(--m-color-background-highlight));
  }

  &[aria-pressed='true'] {
    color: rgb(var(--m-color-brand));
  }

  &:focus-visible {
    outline: 2px solid rgb(var(--m-color-brand));
    outline-offset: 2px;
  }

  /* On touch the targets are 44px tall without making the row taller. */
  @media (hover: none) {
    &::after {
      content: '';
      position: absolute;
      inset: min(0px, (100% - 44px) / 2) 0;
    }
  }
`
